import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { MS_TIME } from "Utils/TimeUtils";
import {
  type EntityListOfEmployeeDto,
  getMerchantsEmployees,
  getMerchantsPublicIDEmployees,
  type SortDirection,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export type EmployeesListParams = {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortDirection?: SortDirection;
  statuses?: Array<string>;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
};

export const merchantEmployeesKeys = {
  all: ["merchantEmployees"] as const,
  lists: () => [...merchantEmployeesKeys.all, "list"] as const,
  list: (merchantPublicID?: string, params?: EmployeesListParams) =>
    [...merchantEmployeesKeys.lists(), merchantPublicID, params] as const,
};

export const useMerchantEmployees = (
  merchantPublicID?: string,
  params: EmployeesListParams = {},
  enabled = true,
) =>
  useQuery<EntityListOfEmployeeDto>({
    queryKey: merchantEmployeesKeys.list(merchantPublicID, params),
    queryFn: processResponseWithApiProblemDetails(() =>
      merchantPublicID
        ? getMerchantsPublicIDEmployees(
            merchantPublicID,
            params.statuses,
            params.firstName,
            params.lastName,
            params.email,
            params.phone,
            params.offset,
            params.limit,
            params.sortBy,
            params.sortDirection,
          )
        : getMerchantsEmployees(
            params.statuses,
            params.firstName,
            params.lastName,
            params.email,
            params.phone,
            params.offset,
            params.limit,
            params.sortBy,
            params.sortDirection,
          ),
    ),
    placeholderData: keepPreviousData,
    staleTime: 5 * MS_TIME.minute,
    enabled,
  });
